import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOpportunitiesSummary } from "@/helpers/apis";
import { GET_SUMMARY_DATA } from "../../constants";
import type { OpportunitiesFilters } from "../../schemas";

interface UseDiscoverSummaryQueryProps {
  filterParams: OpportunitiesFilters;
  isInitialized: boolean;
}

export const useDiscoverSummaryQuery = ({
  filterParams,
  isInitialized,
}: UseDiscoverSummaryQueryProps) => {
  // Forward every filter the summary API supports so the summary tile totals
  // reflect the same filters applied to the opportunities list — including
  // the Databricks Workspace chip (page/size/sort are pagination-only and
  // intentionally excluded to avoid needless refetches).
  const summaryParams = useMemo(
    () => ({
      start_date: filterParams.start_date,
      end_date: filterParams.end_date,
      effort: filterParams.effort,
      resource_name: filterParams.resource_name,
      opportunity_name: filterParams.opportunity_name,
      resource_type: filterParams.resource_type,
      owner: filterParams.owner,
      status: filterParams.status,
      user: filterParams.user,
      warehouse: filterParams.warehouse,
      instance_id: filterParams.instance_id,
      workspace_id: filterParams.workspace_id,
    }),
    [
      filterParams.start_date,
      filterParams.end_date,
      filterParams.effort,
      filterParams.resource_name,
      filterParams.opportunity_name,
      filterParams.resource_type,
      filterParams.owner,
      filterParams.status,
      filterParams.user,
      filterParams.warehouse,
      filterParams.instance_id,
      filterParams.workspace_id,
    ]
  );

  return useQuery({
    queryKey: [GET_SUMMARY_DATA, summaryParams],
    queryFn: () => getOpportunitiesSummary(summaryParams),
    enabled: isInitialized, // Only fetch when URL sync is complete
  });
};
